import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { S, DARK } from '~/app/ui/tokens';

interface Props {
  children: React.ReactNode;
  onClickBack: React.MouseEventHandler<HTMLDivElement>;
  isDarkBackground?: boolean;
  path: string;
}

export default function NavigationBar(props: Props) {
  const {
    children,
    onClickBack,
    isDarkBackground,
    path
  } = props;

  return (
    <Container>
      <BackButton
        onClick={onClickBack}
        show={!!path}
        isDarkBackground={isDarkBackground}
      >
        <i className="material-icons">arrow_back</i>
      Back
      </BackButton>
      <FilePath
        isDarkBackground={isDarkBackground}
      >
        {`Path: /${path}`}
      </FilePath>
      { children }
    </Container>
  );
}

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  position: 'absolute',
  marginTop: '-48px',
  alignItems: 'center',
  width: '95%'
});

const BackButton = styled(Box)<{ isDarkBackground?: boolean, show: boolean }>(({
  isDarkBackground,
  show
}) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '& > i': {
    fontSize: '20px'
  },
  // In the dialog it sits over the header strip, which is S.chrome in both themes now (it used to be dark).
  color: isDarkBackground ? S.fg : 'black',
  visibility: show ? 'visible' : 'hidden',
  [DARK]: { color: S.fg }
}));

const FilePath = styled(Box)<{ isDarkBackground?: boolean }>(({
  isDarkBackground
}) => ({
  marginLeft: '106px',
  flexGrow: '1',
  color: isDarkBackground ? S.fg : 'black',
  [DARK]: { color: S.fg }
}));
